import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classes", "overrides", "className", "option", "value", "isReadOnly", "onChange", "onBlur"],
  _excluded2 = ["value", "isReadOnly", "overrides"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { getOverrides, useClasses } from '../../../utils/overrides';
import RadioBox from '../RadioBox';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'RadioBoxControl');
function RadioBoxControl(_ref) {
  var classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    option = _ref.option,
    value = _ref.value,
    isReadOnly = _ref.isReadOnly,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, RadioBoxControl.overrides);
  var optionValue = option.value,
    optionIsReadOnly = option.isReadOnly,
    optionOverrides = option.overrides,
    optionProps = _objectWithoutProperties(option, _excluded2);
  var onChangeRadio = useCallback(function () {
    onChange && onChange(optionValue);
    onBlur && onBlur(optionValue);
  }, [onBlur, onChange, optionValue]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes.radioBoxControl,
    onClick: isReadOnly || optionIsReadOnly ? undefined : onChangeRadio
  }, override.radioBoxControl), /*#__PURE__*/React.createElement(RadioBox, _extends({}, props, optionProps, {
    checked: value === optionValue,
    isReadOnly: isReadOnly || optionIsReadOnly,
    overrides: _objectSpread(_objectSpread({}, overridesProp.radioBox), optionOverrides)
  })));
}
RadioBoxControl.defaultProps = {
  onChange: function onChange() {},
  option: {},
  isReadOnly: false
};
process.env.NODE_ENV !== "production" ? RadioBoxControl.propTypes = {
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
  value: PropTypes.string,
  isReadOnly: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(RadioBoxControl);